/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReportExportFormats = {
    None: 'None',
    Pdf: 'Pdf',
    Word: 'Word'
} as const;
export type ReportExportFormats = typeof ReportExportFormats[keyof typeof ReportExportFormats];


export function instanceOfReportExportFormats(value: any): boolean {
    for (const key in ReportExportFormats) {
        if (Object.prototype.hasOwnProperty.call(ReportExportFormats, key)) {
            if (ReportExportFormats[key as keyof typeof ReportExportFormats] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReportExportFormatsFromJSON(json: any): ReportExportFormats {
    return ReportExportFormatsFromJSONTyped(json, false);
}

export function ReportExportFormatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportExportFormats {
    return json as ReportExportFormats;
}

export function ReportExportFormatsToJSON(value?: ReportExportFormats | null): any {
    return value as any;
}

export function ReportExportFormatsToJSONTyped(value: any, ignoreDiscriminator: boolean): ReportExportFormats {
    return value as ReportExportFormats;
}

